export default __webpack_public_path__ + "static/media/voltric-lite.30abc320.webp";